let lastHiddenAt = Number.NEGATIVE_INFINITY
let listening = false

const markPageHidden = () => {
  lastHiddenAt = performance.now()
}

const onVisibilityChange = () => {
  if (document.visibilityState === 'hidden') markPageHidden()
}

export function startPageLifecycleTracking(): void {
  if (typeof document === 'undefined' || listening) return

  listening = true
  document.addEventListener('visibilitychange', onVisibilityChange)
  window.addEventListener('pagehide', markPageHidden)
  document.addEventListener('freeze', markPageHidden)

  if (document.visibilityState === 'hidden') markPageHidden()
}

export function isPageHidden(): boolean {
  return typeof document !== 'undefined' && document.visibilityState === 'hidden'
}

export function wasPageHiddenSince(startedAt: number): boolean {
  if (typeof document === 'undefined') return false
  return isPageHidden() || lastHiddenAt >= startedAt
}

export function isBrowserOffline(): boolean {
  return typeof navigator !== 'undefined' && navigator.onLine === false
}

/** @internal */
export function __resetPageLifecycleTrackingForTests(): void {
  if (listening && typeof document !== 'undefined') {
    document.removeEventListener('visibilitychange', onVisibilityChange)
    document.removeEventListener('freeze', markPageHidden)
    if (typeof window !== 'undefined') window.removeEventListener('pagehide', markPageHidden)
  }

  lastHiddenAt = Number.NEGATIVE_INFINITY
  listening = false
}
